/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAirdropTapTip.vue?vue&type=template&id=0ebf1fb9&scoped=true"
import script from "./popAirdropTapTip.vue?vue&type=script&lang=js"
export * from "./popAirdropTapTip.vue?vue&type=script&lang=js"
import style0 from "./popAirdropTapTip.vue?vue&type=style&index=0&id=0ebf1fb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebf1fb9",
  null
  
)

export default component.exports